import React from "react"
import { navigate } from "gatsby"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import ArrowLeft from "-!svg-react-loader!../../assets/icons/nova/arrow-back.svg"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { getPreviousSection } from "../../utils/nextorprevquestionsectionlogic"
import { showVeganQuestions } from "../../utils/versionHelper"

import {
  sectionNameToId,
  sectionNameToNum,
  formattedSectionName,
} from "../../utils/segmentHelpers"

import {
  decrementProgress,
  setProgress,
  setCurrentSection,
  decrementTotalProgress,
  toggleMovingForward,
  decrementMirrorProgress,
} from "../../actions"

const PreviousButton = styled.button`
  //padding-bottom: 2px;
  border-bottom: 1px solid ${theme.wild.color.master.base.black};
  //line-height: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  p {
    line-height: 100% !important;
    //line-height: 12px !important;
    @media (min-width: 768px) {
      //line-height: 14px !important;
    }
    @media (min-width: 1024px) {
      //line-height: 20px !important;
    }
  }
`
const SVGWrap = styled.span`
  display: inline-block;
  vertical-align: middle;
  //transform: translate(-3px, -1px);
  svg {
    width: 16px;
    height: 16px;
    @media (min-width: 1024px) {
      width: 20px;
      height: 20px;
    }
  }
`

const PrevButton = (props) => {
  const { quizProgress, currentSection, gender, age, id, text, token } = props

  const goToPreviousStep = () => {
    if (quizProgress > 0) {
      let prevStepNum = parseInt(props.quizProgress) - 1
      props.decrementProgress(prevStepNum)
      if (typeof window !== `undefined`) {
        localStorage.setItem("quizProgress", prevStepNum)
      }
    }
  }

  const setSection = (name) => {
    props.setCurrentSection(name)
    if (typeof window !== `undefined`) {
      localStorage.setItem("currentSection", name)
    }
  }

  const resetProgress = (prog) => {
    props.setProgress(prog)
    if (typeof window !== `undefined`) {
      localStorage.setItem("quizProgress", prog)
    }
  }

  const goToPreviousSection = () => {
    let prevStepSection = getPreviousSection(currentSection, gender, age)
    let prevStepUrl = "/step/" + prevStepSection
    navigate(prevStepUrl)
    setSection(prevStepSection)
    if (props.sectionLengthStarter[prevStepSection + "length"]) {
      let prevSectionLength =
        props.sectionLengthStarter[prevStepSection + "length"]
      if (
        prevStepSection === "basics" &&
        gender.globalid === "women" &&
        !showVeganQuestions()
      ) {
        resetProgress(prevSectionLength - 1)
      } else if (prevStepSection === "intro") {
        resetProgress(0)
      } else {
        resetProgress(prevSectionLength)
      }
    } else {
      resetProgress(0)
    }
  }

  const trackBackButtonClick = () => {
    let trackName = "Quiz Clicked Back"
    let quizJson = JSON.parse(localStorage.getItem("quizJson"))
    let sectionNum = sectionNameToNum(currentSection)
    let quizProgress = parseInt(localStorage.getItem("quizProgress"))

    // getting the previous Q id and text from JSON + localstorage
    let sectionJson = !!quizJson.sections[sectionNum]
      ? quizJson.sections[sectionNum]
      : quizJson[sectionNum]
    let prevQuestionJson =
      !!sectionJson.questions && !!sectionJson.questions[quizProgress]
        ? sectionJson.questions[quizProgress]
        : sectionJson[quizProgress]

    let backToQuestion =
      !!prevQuestionJson && !!prevQuestionJson.text ? prevQuestionJson.text : ""
    let backToQuestionId =
      !!prevQuestionJson && !!prevQuestionJson.id ? prevQuestionJson.id : ""
    let initialQuestion = text
    let initialQuestionId = id
    let sectionId = sectionNameToId(currentSection)
    let sectionName = currentSection

    segmentEvent(trackName, {
      back_to_question: backToQuestion,
      back_to_question_id: backToQuestionId,
      initial_question: initialQuestion,
      initial_question_id: initialQuestionId,
      section_id: sectionId,
      section_name: formattedSectionName(sectionName),
      userToken: token,
    })
  }

  const progressBarPrevStep = () => {
    if (quizProgress > 0) {
      let prevStepNum = parseInt(props.quizProgress) - 1
      props.decrementMirrorProgress(prevStepNum)
    }
  }

  const prevQuestionOrSection = () => {
    if (props.updateMounted) {
      props.updateMounted(false)
    }

    if (props.triggerGlobalUnmount) {
      props.triggerGlobalUnmount(true)
      setTimeout(() => {
        props.triggerGlobalUnmount(false)
      }, 2001)
    }

    props.toggleMovingForward(false)

    if (quizProgress !== 0) {
      progressBarPrevStep()
    }

    if (props.currentSection === "intro" && quizProgress === 0) {
      props.setProgress(0)
      return setTimeout(() => navigate("/"), 501)
    }

    setTimeout(() => {
      quizProgress === 0 ? goToPreviousSection() : goToPreviousStep()

      trackBackButtonClick()
    }, 350)
  }

  return (
    <PreviousButton onClick={prevQuestionOrSection}>
      <SVGWrap>
        <ArrowLeft />
      </SVGWrap>
      <TextElementNova
        text={`Back`}
        element="p"
        className=" text-nova-base-black CTA-10-Dia-Normal show-small-only"
      />
      <TextElementNova
        text={`Previous`}
        element="p"
        className=" text-nova-base-black CTA-10-Dia-Normal hide-small-only"
      />
    </PreviousButton>
  )
}

const mapStateToProps = (state) => {
  return {
    quizProgress: state.progressReducer.quizProgress,
    currentSection: state.sectionReducer.currentSection,
    gender: state.genderReducer.gender,
    age: state.ageReducer.age,
    sectionLength: state.sectionLengthReducer.sectionLength,
    sectionLengthStarter: state.dynamicSectionLengthReducer,
  }
}

export default connect(mapStateToProps, {
  setProgress,
  decrementProgress,
  setCurrentSection,
  decrementTotalProgress,
  toggleMovingForward,
  decrementMirrorProgress,
})(PrevButton)
